export const GET_MESSAGGI_VOCALI_DATA = "GET_MESSAGGI_VOCALI_DATA_AND_LOADING";
export const GET_MESSAGI_VOCALI_CREATE_DROPDOWNS =
  "GET_MESSAGI_VOCALI_CREATE_DROPDOWNS";
export const CREATE_UPDATE_DELETE_MESSAGGI_VOCALI =
  "CREATE_UPDATE_DELETE_MESSAGGI_VOCALI";
export const GET_CURRENT_MESSAGGI_VOCALE = "GET_CURRENT_MESSAGGI_VOCALE";
export const EXPORT_MESSAGGI_VOCALI_LOADING = "EXPORT_MESSAGGI_VOCALI_LOADING";
